// extracted by mini-css-extract-plugin
export default {"family_card":"FamilyCard_family_card__cgCfD","desi_card_main_img":"FamilyCard_desi_card_main_img__UtbgA","barcode":"FamilyCard_barcode__HRVbx","name":"FamilyCard_name__GWy9V"};